// extracted by mini-css-extract-plugin
export var actions = "_ug-4";
export var item = "_ug-1";
export var price = "_ug-3";
export var quantity = "_ug-2";
export var table = "_ug-0";